import React from 'react';

const AuthForm = ({
  email,
  password,
  setEmail,
  setPassword,
  handleSignIn,
  error,
}) => {
  return (
    <div className='auth-form'>
      <form onSubmit={handleSignIn}>
        <input
          type='email'
          placeholder='Email'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <input
          type='password'
          placeholder='Пароль'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        {error && <p className='error-message'>{error}</p>}
        <button type='submit' className='auth-button'>
          Увійти
        </button>
      </form>
    </div>
  );
};

export default AuthForm;
